export default function FlowBadges({ editingExisting, savedId, dirty }) {
  const hasSaved = Boolean(savedId);
  if (editingExisting) {
    return (
      <div
        className="mb-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[11px] uppercase tracking-wider bg-[#C5A880]/10 border border-[#C5A880]/30 text-[#C5A880]"
        data-testid="editing-badge"
      >
        Editing · Ref #{savedId?.slice(0, 8)}
        {dirty && <span className="text-amber-400 normal-case tracking-normal">· Unsaved changes</span>}
      </div>
    );
  }
  if (!hasSaved) return null;
  return (
    <div
      className="mb-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[11px] uppercase tracking-wider bg-[#32D74B]/10 border border-[#32D74B]/30 text-[#32D74B]"
      data-testid="saved-badge"
    >
      Saved · #{savedId.slice(0, 8)}
      {dirty && <span className="text-amber-400 normal-case tracking-normal">· Unsaved changes</span>}
    </div>
  );
}
